import React from 'react';
import { JobContainer, TitleWrapper, Title, JobWrapper, JobWrapper2, ContactWrapper, ContactLink, ListingWrapper, BulletDiv, Header, Button, Header2, Subheader } from './JobElements';

const JobsSection = ({
    title, title2, target, contact,
    jobHeader1, jobLink1, jobButton1,
    jobHeader2, jobLink2, jobButton2,
    jobHeader3, jobLink3, jobButton3,
    jobHeader4, jobLink4, jobButton4,
    jobHeader5, jobLink5, jobButton5,
    jobHeader6, jobLink6, jobButton6,
}) => {
    
    return (
        <>
            <JobContainer>
                <TitleWrapper>
                    <Title>
                        {title}
                    </Title>
                </TitleWrapper>
                <ContactWrapper>
                    <Header>Contact <ContactLink href="mailto:jimolson@attochron.com">{contact}</ContactLink></Header>
                </ContactWrapper>
                <JobWrapper>
                    <ListingWrapper>
                        <Header>{jobHeader6}<Button to={jobLink6} target={target}>{jobButton6}</Button></Header>
                    </ListingWrapper>
                    <ListingWrapper>
                        <Header>{jobHeader1}<Button to={jobLink1} target={target}>{jobButton1}</Button></Header>
                    </ListingWrapper>
                    <ListingWrapper>
                        <Header>{jobHeader2}<Button to={jobLink2} target={target}>{jobButton2}</Button></Header>
                    </ListingWrapper>
                    <ListingWrapper>
                        <Header>{jobHeader3}<Button to={jobLink3} target={target}>{jobButton3}</Button></Header>
                    </ListingWrapper>
                    <ListingWrapper>
                        <Header>{jobHeader4}<Button to={jobLink4} target={target}>{jobButton4}</Button></Header>
                    </ListingWrapper>
                    <ListingWrapper>
                        <Header>{jobHeader5}<Button to={jobLink5} target={target}>{jobButton5}</Button></Header>
                    </ListingWrapper>
                </JobWrapper>
                <TitleWrapper>
                    <Title>
                        {title2}
                    </Title>
                </TitleWrapper>
                <JobWrapper2>
                    <Header2>Lexington Area Videos</Header2>
                    <Subheader>Visiting and Living</Subheader>
                    <BulletDiv>
                    <ul class="bullet">
                        <li class="bullet"><ContactLink href="https://www.youtube.com/watch?v=m23Osbd9ZXA" target={target}>https://www.youtube.com/watch?v=m23Osbd9ZXA</ContactLink></li>
                        <li class="bullet"><ContactLink href="https://www.youtube.com/watch?v=ggpjoZK01vE" target={target}>https://www.youtube.com/watch?v=ggpjoZK01vE</ContactLink></li>
                        <li class="bullet"><ContactLink href="https://www.youtube.com/watch?v=cEOqtMGPmkM" target={target}>https://www.youtube.com/watch?v=cEOqtMGPmkM</ContactLink></li>
                        <li class="bullet"><strong>Carriage Rides: </strong><ContactLink href="https://www.youtube.com/watch?v=LJmxtnEy-Q4" target={target}>https://www.youtube.com/watch?v=LJmxtnEy-Q4</ContactLink></li>
                        <li class="bullet"><strong>Rockbridge Life Site: </strong><ContactLink href="https://www.rockbridge.life/" target={target}>https://www.rockbridge.life/</ContactLink></li>
                        <li class="bullet"><strong>Lexington Gazette (local news): </strong><ContactLink href="https://www.thenews-gazette.com/" target={target}>https://www.thenews-gazette.com/</ContactLink></li>
                        <li class="bullet"><strong>Visiting Lexington Brochure: </strong><ContactLink href="https://publisher.etype.services/Lexington-News-Gazette/e-paper-special-edition/FD9163BE7428DC39" target={target}>https://publisher.etype.services/Lexington-News-Gazette/e-paper-special-edition/FD9163BE7428DC39</ContactLink></li>
                    </ul>
                    </BulletDiv>
                    <Subheader>History</Subheader>
                    <BulletDiv>
                    <ul class="bullet">
                        <li class="bullet"><ContactLink href="https://www.youtube.com/watch?v=R66TU5ZdOdw" target={target}>https://www.youtube.com/watch?v=R66TU5ZdOdw</ContactLink></li>
                        <li class="bullet"><ContactLink href="https://www.youtube.com/watch?v=LmOHSyLCd5U" target={target}>https://www.youtube.com/watch?v=LmOHSyLCd5U</ContactLink></li>
                        <li class="bullet"><strong>Wade's Mill: </strong><ContactLink href="https://www.youtube.com/watch?v=h5RLoF8X6nQ" target={target}>https://www.youtube.com/watch?v=h5RLoF8X6nQ</ContactLink></li>
                    </ul>
                    </BulletDiv>
                    <Subheader>Nearby Places and Cities</Subheader>
                    <BulletDiv>
                    <ul class="bullet">
                        <li class="bullet"><strong>House Mountain (very close): </strong><ContactLink href="https://www.youtube.com/watch?v=W1_tVa2Rhm8" target={target}>https://www.youtube.com/watch?v=W1_tVa2Rhm8</ContactLink></li>
                        <li class="bullet"><strong>Staunton (30 minutes by car): </strong><ContactLink href="https://www.youtube.com/watch?v=DVmooSqdGBA" target={target}>https://www.youtube.com/watch?v=DVmooSqdGBA</ContactLink></li>
                        <li class="bullet"><strong>Scenic Train Rides: </strong><ContactLink href="https://www.youtube.com/watch?v=AwiyEoR_LxY" target={target}>https://www.youtube.com/watch?v=AwiyEoR_LxY</ContactLink></li>
                    </ul>
                    </BulletDiv>
                </JobWrapper2>
            </JobContainer>
        </>
    )
}

export default JobsSection;